import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './pages/Profile.translations'

function onboardingRoutes(): RouteRecordRaw[] {
  return [
    {
      component: () => import('~/scopes/profile/pages/Profile.vue'),
      redirect: { name: ROUTE_NAMES.ONBOARDING.PROFILE.HOME },
      name: ROUTE_NAMES.ONBOARDING.PROFILE.INDEX,
      path: '/bo-seller/onboarding/profile',
      meta: {
        autonomousBannerPageName: 'onboarding-profile',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          component: () => import('~/scopes/profile/pages/tabs/home/Home.vue'),
          name: ROUTE_NAMES.ONBOARDING.PROFILE.HOME,
          path: 'home',
          meta: {
            autonomousBannerPageName: 'onboarding-profile.home',
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/profile/pages/tabs/company-info/CompanyInfo.vue'),
          name: ROUTE_NAMES.ONBOARDING.PROFILE.COMPANY_INFO,
          path: 'company-info',
          meta: {
            autonomousBannerPageName: 'onboarding-profile.company-info',
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import(
              '~/scopes/profile/pages/tabs/legal-details/LegalDetails.vue'
            ),
          name: ROUTE_NAMES.ONBOARDING.PROFILE.LEGAL_DETAILS,
          path: 'legal-details',
          meta: {
            autonomousBannerPageName: 'onboarding-profile.legal-details',
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import(
              '~/scopes/profile/pages/tabs/contact-details/ContactDetails.vue'
            ),
          name: ROUTE_NAMES.ONBOARDING.PROFILE.CONTACT_DETAILS,
          path: 'contact-details',
          meta: {
            autonomousBannerPageName: 'onboarding-profile.contact-details',
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import(
              '~/scopes/profile/pages/tabs/user-permissions/UserPermissions.vue'
            ),
          name: ROUTE_NAMES.ONBOARDING.PROFILE.USER_PERMISSIONS,
          path: 'user-permissions',
          meta: {
            autonomousBannerPageName: 'onboarding-profile.user-permissions',
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
  ]
}

const routes = (): RouteRecordRaw[] => {
  return [
    ...onboardingRoutes(),
    {
      component: () => import('~/scopes/profile/pages/Profile.vue'),
      redirect: { name: ROUTE_NAMES.PROFILE.HOME },
      name: ROUTE_NAMES.PROFILE.INDEX,
      path: '/bo-seller/profile',
      meta: {
        autonomousBannerPageName: 'profile',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          component: () => import('~/scopes/profile/pages/tabs/home/Home.vue'),
          name: ROUTE_NAMES.PROFILE.HOME,
          path: 'home',
          meta: {
            autonomousBannerPageName: 'profile.home',
            tabItem: {
              label: translations.homeTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/profile/pages/tabs/company-info/CompanyInfo.vue'),
          name: ROUTE_NAMES.PROFILE.COMPANY_INFO,
          path: 'company-info',
          meta: {
            autonomousBannerPageName: 'profile.company-info',
            tabItem: {
              label: translations.companyInfoTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import(
              '~/scopes/profile/pages/tabs/legal-details/LegalDetails.vue'
            ),
          name: ROUTE_NAMES.PROFILE.LEGAL_DETAILS,
          path: 'legal-details',
          meta: {
            autonomousBannerPageName: 'profile.legal-details',
            tabItem: {
              label: translations.legalDetailsTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import(
              '~/scopes/profile/pages/tabs/contact-details/ContactDetails.vue'
            ),
          name: ROUTE_NAMES.PROFILE.CONTACT_DETAILS,
          path: 'contact-details',
          meta: {
            autonomousBannerPageName: 'profile.contact-details',
            tabItem: {
              label: translations.contactDetailsTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import(
              '~/scopes/profile/pages/tabs/user-permissions/UserPermissions.vue'
            ),
          name: ROUTE_NAMES.PROFILE.USER_PERMISSIONS,
          path: 'user-permissions',
          meta: {
            autonomousBannerPageName: 'profile.user-permissions',
            tabItem: {
              label: translations.userPermissionsTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
  ]
}

export default routes
